import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@stepflow/ui-shell/App.jsx';
import './index.css';

// LOCAL DEV (doc/dev/LOCAL_DEV_STACK.md): the dev-auth bypass has no Cognito session, so the AppSync
// realtime socket can't authorize (401 → no live stream). Before rendering, pull the REAL token from
// the dev-server's saved sf_login session (`GET /_dev/token`) and seed localStorage, so BOTH REST and
// the AppSync subscription use a real, valid token → live streaming locally. Strictly gated on
// VITE_LOCAL_DEV_AUTH (only ever set in a gitignored .env.local by dev.sh) → a no-op in prod.
async function seedLocalDevToken() {
  if (import.meta.env.VITE_LOCAL_DEV_AUTH !== '1') return;
  try {
    const base = import.meta.env.VITE_API_BASE_URL || '';
    const r = await fetch(`${base}/_dev/token`);
    if (!r.ok) return;
    const t = await r.json();
    if (t.idToken) {
      localStorage.setItem('idToken', t.idToken);
      if (t.accessToken) localStorage.setItem('accessToken', t.accessToken);
      // eslint-disable-next-line no-console
      console.info('[local-dev] seeded real Cognito token → AppSync streaming enabled');
    } else {
      // eslint-disable-next-line no-console
      console.warn(`[local-dev] no valid token (${t.hint || 'run sf_login'}) — AppSync will 401 until refreshed`);
    }
  } catch {
    /* dev-server offline or endpoint absent — non-fatal */
  }
}

// KEEP the token fresh for the whole session. The AppSync realtime socket has a 300s connection
// timeout, so any run > 5 min forces a reconnect; the reconnect re-reads localStorage.idToken and a
// STALE token there fails re-subscribe (UnauthorizedException → subscription dead → the run's terminal
// beacon is lost live → "started well but never finished"). The dev-server mints from the 30-day
// refresh token, so re-seeding every 45 min keeps localStorage valid across long sessions/runs — the
// local analog of the deployed app's Cognito auto-refresh. Dev-only (gated inside seedLocalDevToken).
if (import.meta.env.VITE_LOCAL_DEV_AUTH === '1') {
  setInterval(() => { seedLocalDevToken(); }, 45 * 60 * 1000);
}

seedLocalDevToken().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
